module.exports = __webpack_public_path__ + "static/media/telemed icon (active).9381ed4c.svg";